<template>
    <div class="wraper-loginreg register" v-if="pageStatus">
        <div class="main">
            <img class="open-img" src="../assets/open.png" alt="open" />
            <div class="wraper-main">
                <div class="main-inner register-inner">
                    <el-scrollbar class="scrollbar">
                        <div class="register-body">
                            <div class="logo-btn-box">
                                <img
                                    class="logo"
                                    src="@/assets/logo.png"
                                    alt="logo"
                                />
                            </div>
                            <div class="title">注册</div>
                            <div class="tab">
                                <div
                                    :class="[
                                        'tab-item-main',
                                        formData.user_remark_001 == 101 ? 'active' : '',
                                    ]"
                                    @click="handleSelRegisterType(101)"
                                >
                                    <div class="tab-item tab-item-people">
                                        <div class="icon-box"></div>
                                        <div class="item-name">个人</div>
                                    </div>
                                </div>
                                <div
                                    :class="[
                                        'tab-item-main',
                                        formData.user_remark_001 == 102 ? 'active' : '',
                                    ]"
                                    @click="handleSelRegisterType(102)"
                                >
                                <div class="tab-item tab-item-supplier">
                                    <div class="icon-box"></div>
                                    <div class="item-name">服务商</div>
                                </div>
                                </div>
                            </div>
                            <el-form
                                class="form-box register-form"
                                ref="registerForm"
                                :label-position="labelPosition"
                                label-width="0"
                                :model="formData"
                                :rules="rules"
                            >
                                <div>
                                    <!-- 个人部分 -->
                                    <div
                                        class="form-item"
                                        v-show="formData.user_remark_001 == 101"
                                    >
                                        <div class="label">
                                            身份<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="user_remark_002">
                                            <CustomSelect
                                                class="width100per"
                                                style="min-height: 46px"
                                                :multiple-limit="3"
                                                multiple
                                                v-model="formData.user_remark_002"
                                                placeholder="请选择（最多3个）"
                                                popper-class="customselect-popper"
                                                value-key="value"
                                                otherValue="212"
                                            >
                                                <el-option
                                                    v-for="(item, idx) in identityOptionsRegister"
                                                    :key="idx"
                                                    :label="item.text"
                                                    :value="item"
                                                    :remark="item.value"
                                                >
                                                </el-option>
                                            </CustomSelect>
                                        </el-form-item>
                                    </div>
                                    <div
                                        class="form-item"
                                        v-show="formData.user_remark_001 == 101"
                                    >
                                        <div class="label">
                                            姓名<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="nick_name">
                                        <el-input
                                            class="custom-input"
                                            v-model="formData.nick_name"
                                            placeholder="请输入"
                                            maxlength="32"
                                        ></el-input>
                                        </el-form-item>
                                    </div>
                                    <!-- 公司部分 -->
                                    <div
                                        class="form-item"
                                        v-show="formData.user_remark_001 == 102"
                                    >
                                        <div class="label">
                                            公司名称<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="user_remark_005">
                                            <el-input
                                                class="custom-input"
                                                v-model="formData.user_remark_005"
                                                placeholder="请输入"
                                                maxlength="100"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                    <div
                                        class="form-item"
                                        v-show="formData.user_remark_001 == 102"
                                    >
                                        <div class="label">
                                            姓名<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="nick_name">
                                            <el-input
                                                class="custom-input"
                                                v-model="formData.nick_name"
                                                placeholder="请输入"
                                                maxlength="32"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                    <div
                                        class="form-item"
                                        v-show="formData.user_remark_001 == 102"
                                    >
                                        <div class="label">
                                            开发地<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="user_remark_007">
                                            <CustomSelectCity
                                                class="width100per"
                                                style="min-height: 46px"
                                                @changeLetter="handleChangeLetter"
                                                multiple
                                                v-model="formData.user_remark_007"
                                                placeholder="请选择"
                                                popper-class="customselect-popper"
                                                value-key="cityid"
                                            >
                                                <el-option
                                                    v-for="(item, idx) in cityOptions"
                                                    :key="idx"
                                                    :label="item.name"
                                                    :value="item"
                                                >
                                                </el-option>
                                            </CustomSelectCity>
                                        </el-form-item>
                                    </div>
                                    <div
                                        class="form-item"
                                        v-show="formData.user_remark_001 == 102"
                                    >
                                        <div class="label">
                                            身份<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="user_remark_002">
                                            <CustomSelect
                                                class="width100per"
                                                style="min-height: 46px"
                                                :multiple-limit="3"
                                                multiple
                                                v-model="formData.user_remark_002"
                                                placeholder="请选择（最多3个）"
                                                popper-class="customselect-popper"
                                                value-key="value"
                                                otherValue="212"
                                            >
                                                <el-option
                                                    v-for="(item, idx) in identityOptionsRegister"
                                                    :key="idx"
                                                    :label="item.text"
                                                    :value="item"
                                                    :remark="item.value"
                                                >
                                                </el-option>
                                            </CustomSelect>
                                        </el-form-item>
                                    </div>
                                    <div
                                        class="form-item"
                                        v-show="formData.user_remark_001 == 102"
                                    >
                                        <div class="label">
                                            团队人数<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="user_remark_006">
                                            <el-input
                                                class="custom-input"
                                                v-model="formData.user_remark_006"
                                                placeholder="请输入"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                    <div
                                        class="form-item"
                                        v-show="formData.user_remark_001 == 102"
                                    >
                                        <div class="label">
                                            行业<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="user_remark_008">
                                            <CustomSelect
                                                class="width100per"
                                                style="min-height: 46px"
                                                multiple
                                                v-model="formData.user_remark_008"
                                                placeholder="请选择"
                                                popper-class="customselect-popper"
                                                value-key="value"
                                                otherValue="810"
                                            >
                                                <el-option
                                                    v-for="(item, idx) in industryOptions"
                                                    :key="idx"
                                                    :label="item.text"
                                                    :value="item"
                                                    :remark="item.value"
                                                >
                                                </el-option>
                                            </CustomSelect>
                                        </el-form-item>
                                    </div>
                                    <!-- 开发/供应商相同部分 -->
                                    <div class="form-item">
                                        <div class="label">
                                            开发语言<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="user_remark_003">
                                            <CustomSelect
                                                class="width100per"
                                                style="min-height: 46px"
                                                :multiple-limit="3"
                                                multiple
                                                v-model="formData.user_remark_003"
                                                placeholder="请选择"
                                                popper-class="customselect-popper"
                                                value-key="value"
                                                otherValue="329"
                                            >
                                                <el-option
                                                    v-for="(item, idx) in devlangOptions"
                                                    :key="idx"
                                                    :label="item.text"
                                                    :value="item"
                                                    :remark="item.value"
                                                >
                                                </el-option>
                                            </CustomSelect>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <div class="label">
                                            邮箱账号<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="user_email">
                                            <el-input
                                                class="custom-input"
                                                v-model="formData.user_email"
                                                placeholder="请输入"
                                                maxlength="32"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <div class="label">
                                            手机号<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="user_phone">
                                            <el-input
                                                class="custom-input"
                                                v-model="formData.user_phone"
                                                placeholder="请输入"
                                                maxlength="11"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <div class="label">
                                            验证码<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="pic_code">
                                            <el-input
                                                class="custom-input verifycode"
                                                v-model="formData.pic_code"
                                                placeholder="请输入"
                                            ></el-input>
                                            <img
                                                class="img-code"
                                                :src="imgCodeUrl"
                                                @click="refreshImgCode"
                                            />
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <div class="label">
                                            手机验证码<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="msg_content">
                                            <el-input
                                                class="custom-input phonecode"
                                                v-model="formData.msg_content"
                                                placeholder="请输入"
                                            ></el-input>
                                            <el-button
                                                class="custom-button btn-fff3f3 inputtext-button btn-phonecode"
                                                @click="handleSendPhoneCode"
                                            >{{ sendCodeText }}</el-button>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item">
                                        <div class="label">
                                            密码<span class="requiredcolor">*</span>
                                        </div>
                                        <el-form-item prop="password_user">
                                            <el-input
                                                class="custom-input inputtext-password"
                                                v-model="formData.password_user"
                                                placeholder="请输入"
                                                type="password"
                                                show-password
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <el-button
                                    class="custom-button btn-ff3333 btn-operate btn-registernow"
                                    :disabled="isDisableRegister"
                                    @click="handelRegNow"
                                >立即注册</el-button>
                            </el-form>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { phoneValidator, mailValidator, positiveIntegerValidator, passwordValidator } from "@/assets/js/util";
import {
  identityOptionsRegister,
  developLangOptions,
  industryOptions,
  hotCites,
} from "@/assets/js/dictionary";
import CustomSelect from "@/components/CustomSelect.vue";
import CustomSelectCity from "@/components/CustomSelectCity.vue";
// import cityData from "@/utils/city";
import cityData from "@/utils/cityjs/developaddress";
import accountApi from "@/api/account";
import imgCodeApi from "@/api/imgcode";
import pageCommon from "@/utils/pagecommon";
import lodash from "lodash";
import sendpohnecodeMixin from "@/views/mixins/sendphonecode";
export default {
    name: "RegisterUpline",
    mixins: [sendpohnecodeMixin],
    components: {
        CustomSelect,
        CustomSelectCity,
    },
    data() {
        return {
            registerType: 101,
            labelPosition: "top",
            identityOptionsRegister: lodash.cloneDeep(identityOptionsRegister),
            devlangOptions: lodash.cloneDeep(developLangOptions),
            industryOptions: lodash.cloneDeep(industryOptions),
            hotCites: lodash.cloneDeep(hotCites),
            formData: {
                //基本信息
                user_phone: "",
                password_user: "",
                msg_content: "",
                pic_code: "",
                //用户类型,默认101,个人：101，服务商：102
                user_remark_001: 101,
                //用户身份
                user_remark_002: [],
                //身份其他备注
                user_remark_009: "",
                //开发语言
                user_remark_003: [],
                //开发语言其他备注
                user_remark_010: "",
                //用户来源
                user_remark_004: 401,
                //公司名称
                user_remark_005: "",
                //团队人数
                user_remark_006: "",
                //开发地
                user_remark_007: [],
                //行业
                user_remark_008: [],
                // 行业其他备注
                user_remark_011: "",
                nick_name: "",
                user_email: "",
                upline_id_user: ""
            },
            //发送验证码操作
            sendphoneValideForName: "registerForm",
            sendPhoneFormeDataName: "formData",
            valideFieldPhoneItemName: "user_phone",
            valideFieldPicCode: "pic_code",
            //发送验证码结束------------------------
            imgCodeUrl: "",
            cityOptions: [],
            rules: {
                user_remark_002: [
                    { required: true, message: "选择身份", trigger: "change" },
                    { required: true, message: "选择身份", trigger: "blur" },
                ],
                user_remark_003: [
                    { required: true, message: "选择开发语言", trigger: "change" },
                ],
                user_remark_005: [
                    { required: true, message: "填写公司名称", trigger: "blur" },
                ],
                user_remark_006: [
                    { required: true, message: "填写团队人数", trigger: "blur" },
                    { validator: positiveIntegerValidator, trigger: "blur" },
                ],
                user_remark_007: [
                    { required: true, message: "选择开发地", trigger: "change" },
                ],
                user_remark_008: [
                    { required: true, message: "选择行业", trigger: "change" },
                ],
                nick_name: [
                    { required: true, message: "填写姓名", trigger: "blur" }
                ],
                user_email: [
                    { required: true, message: "填写邮箱", trigger: "change" },
                    { validator: mailValidator, trigger: "change" },
                ],
                msg_content: [
                    { required: true, message: "填写手机验证码", trigger: "blur" },
                ],
                pic_code: [
                    { required: true, message: "填写验证码", trigger: "blur" }
                ],
                password_user: [
                    { required: true, message: "填写密码", trigger: "change" },
                    { validator: passwordValidator, trigger: "change" },
                ],
                user_phone: [
                    { required: true, message: "填写正确的手机号码", trigger: "blur" },
                    { validator: phoneValidator, trigger: "blur" },
                ],
            },
            isRequesting: false,
            pageStatus:false,
        };
    },
    computed: {
        isDisableRegister: function () {
            let _this = this;
            if (
                _this.formData.user_remark_002.length > 0 &&
                _this.formData.nick_name &&
                _this.formData.user_remark_003.length > 0 &&
                _this.formData.user_email &&
                _this.formData.user_phone &&
                _this.formData.msg_content &&
                _this.formData.pic_code &&
                _this.formData.password_user
            ) {
                if (_this.formData.user_remark_001 == 102) {
                    if (
                        _this.formData.user_remark_007.length > 0 &&
                        _this.formData.user_remark_006 &&
                        _this.formData.user_remark_008.length > 0
                    ) {
                        return false;
                    }
                    return true;
                }
                return false;
            } else {
                return true;
            }
        },
    },
    mounted() {
        let _this = this;
        let status = this.checkMobile();
        console.log(status)
        if(status){
            window.location.href = "https://duzikai.downline.cn/004_mobile_web_site_duzikai_official_website/dist/front_page_index.html#/registerUpline?upline_id="+_this.$route.query.upline_id;
        }else{
            _this.pageStatus=true;
            _this.refreshImgCode();
            _this.cityOptions = _this.hotCites;
        }
    },
    methods: {
        checkMobile: function () {
            var pda_user_agent_list = new Array("2.0 MMP", "240320", "AvantGo", "BlackBerry", "Blazer",
                "Cellphone", "Danger", "DoCoMo", "Elaine/3.0", "EudoraWeb", "hiptop", "IEMobile", "KYOCERA/WX310K", "LG/U990",
                "MIDP-2.0", "MMEF20", "MOT-V", "NetFront", "Newt", "Nintendo Wii", "Nitro", "Nokia",
                "Opera Mini", "Opera Mobi",
                "Palm", "Playstation Portable", "portalmmm", "Proxinet", "ProxiNet",
                "SHARP-TQ-GX10", "Small", "SonyEricsson", "Symbian OS", "SymbianOS", "TS21i-10", "UP.Browser", "UP.Link",
                "Windows CE", "WinWAP", "Android", "iPhone", "iPod", "iPad", "Windows Phone", "HTC"/*, "GTB"*/);
            var pda_app_name_list = new Array("Microsoft Pocket Internet Explorer");
            var user_agent = navigator.userAgent.toString();
            for (var i = 0; i < pda_user_agent_list.length; i++) {
                if (user_agent.indexOf(pda_user_agent_list[i]) >= 0) {
                return true;
                }
            }
            for (var i = 0; i < pda_app_name_list.length; i++) {
                if (user_agent.indexOf(pda_app_name_list[i]) >= 0) {
                    return true;
                }
            }
            return false;
        },
        refreshImgCode: function () {
            let _this = this;
            let imgCodeObj = imgCodeApi.getImgCodeUrl();
            _this.imgCodeUrl = imgCodeObj.url;
        },
        handleChangeLetter: function (idx) {
            let _this = this;
            let cityOptions = [];
            if (idx == -1) {
                cityOptions = _this.hotCites;
            } else {
                cityOptions = _this.getCityByIdx(idx);
            }
            _this.cityOptions = cityOptions;
        },
        getCityByIdx: function (idx) {
            let letters = [
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z",
            ];
            let cityOptions = [];
            for (let i = idx * 4; i < (idx + 1) * 4 && i < letters.length; i++) {
                const letter = letters[i];
                for (let j = 0; j < cityData.length; j++) {
                const city = cityData[j];
                if (city.tags.indexOf(letter) == 0) {
                    cityOptions.push(city);
                }
                }
            }
            return cityOptions;
        },
        handleToLogin: function () {
            let _this = this;
            _this.$router.push("/login");
        },
        handleSelRegisterType: function (type) {
            let _this = this;
            if (_this.formData.user_remark_001 == type) {
                return;
            }
            _this.formData.user_remark_001 = type;
        },
        handleToReset: function () {
            let _this = this;
            _this.$router.push("/resetpwd");
        },
        handelRegNow: function () {
            let _this = this;
            var testName = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]") 
            if(_this.formData.nick_name&&testName.test(_this.formData.nick_name)){
                _this.$message.error("姓名不能包含特殊字符！");
                return;
            }
            if (_this.isRequesting) {
                return;
            }
            _this.isRequesting = true;
            let fields = [
                "user_remark_002",
                "nick_name",
                "user_remark_003",
                "user_email",
                "user_phone",
                "msg_content",
                "pic_code",
                "password_user",
            ];
            if (_this.formData.user_remark_001 == 102) {
                fields.push("user_remark_007");
                fields.push("user_remark_006");
                fields.push("user_remark_008");
            }
            Promise.all(
                fields.map((item) => {
                return new Promise((resolve, reject) => {
                    this.$refs["registerForm"].validateField(item, (result) => {
                    resolve(result);
                    });
                });
                })
            ).then((result) => {
                let valid = true;
                for (let i = 0; i < result.length; i++) {
                const element = result[i];
                if (element) {
                    valid = false;
                    break;
                }
                }
                if (valid) {
                let baseRegister = {
                    user_phone: _this.formData.user_phone,
                    password_user: _this.formData.password_user,
                    pic_code: _this.formData.pic_code,
                    msg_content: _this.formData.msg_content,
                };
                // //用户身份
                // user_remark_002: [],
                // //身份其他备注
                // user_remark_009: "",
                // //开发语言
                // user_remark_003: [],
                // //开发语言其他备注
                // user_remark_010: "",
                // //用户来源
                // user_remark_004: 401,
                // //公司名称
                // user_remark_005: "",
                // //团队人数
                // user_remark_006: "",
                // //开发地
                // user_remark_007: [],
                // //行业
                // user_remark_008: [],
                // // 行业其他备注
                // user_remark_011: "",
                // nick_name: "",
                // user_email: "",
                let user_remark_002_values = [];
                let user_remark_009 = "";
                for (let i = 0; i < _this.formData.user_remark_002.length; i++) {
                    const element = _this.formData.user_remark_002[i];
                    user_remark_002_values.push(element.value);
                    if (element.value == "212") {
                        user_remark_009 = element.remark;
                    }
                }
                let user_remark_003_values = [];
                let user_remark_010 = "";
                for (let i = 0; i < _this.formData.user_remark_003.length; i++) {
                    const element = _this.formData.user_remark_003[i];
                    user_remark_003_values.push(element.value);
                    if (element.value == "329") {
                        user_remark_010 = element.remark;
                    }
                }
                let user_remark_007_values = [];
                for (let i = 0; i < _this.formData.user_remark_007.length; i++) {
                    const element = _this.formData.user_remark_007[i];
                    user_remark_007_values.push(element.cityid);
                }
                let user_remark_008_values = [];
                let user_remark_011 = "";
                for (let i = 0; i < _this.formData.user_remark_008.length; i++) {
                    const element = _this.formData.user_remark_008[i];
                    user_remark_008_values.push(element.value);
                    if (element.value == "810") {
                        user_remark_011 = element.remark;
                    }
                }
                let changeUserInfo = {
                    id_public_user_info: "",
                    nick_name: _this.formData.nick_name,
                    user_email: _this.formData.user_email,
                    user_remark_001: _this.formData.user_remark_001,
                    user_remark_002: user_remark_002_values.join(","),
                    user_remark_009: user_remark_009,
                    user_remark_003: user_remark_003_values.join(","),
                    user_remark_010: user_remark_010,
                    user_remark_004: 401,
                    user_remark_005: _this.formData.user_remark_005,
                    user_remark_006: _this.formData.user_remark_006,
                    user_remark_007: user_remark_007_values.join(","),
                    user_remark_008: user_remark_008_values.join(","),
                    user_remark_011: user_remark_011,
                };
                _this.systempUserLoginAndReg(baseRegister, changeUserInfo);
                } else {
                    _this.isRequesting = false;
                }
            });
        },
        systempUserLoginAndReg: function (baseRegister, changeUserInfo) {
            let _this = this;
            let requestData = {
                user_phone: baseRegister.user_phone,
                password_user: baseRegister.password_user,
                pic_code: baseRegister.pic_code,
                msg_content: baseRegister.msg_content,
                isloading: false,
            };
            pageCommon.apiRequestCommon(accountApi, "registerUser", requestData).then(
                (res) => {
                    changeUserInfo.id_public_user_info = res.userInfo.id_public_user_info;
                    _this.regChangeUserInfo(changeUserInfo);
                },
                (err) => {
                    _this.isRequesting = false;
                if (err.sysUserLoginError) {
                    _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                    _this.$message.error(err.data.msg);
                }
                }
            );
        },
        regChangeUserInfo: function (changeUerInfo) {
            let _this = this;
            let requestData = {
                id_public_user_info: changeUerInfo.id_public_user_info,
                nick_name: changeUerInfo.nick_name,
                user_remark_001: changeUerInfo.user_remark_001,
                user_remark_002: changeUerInfo.user_remark_002,
                user_remark_009: changeUerInfo.user_remark_009,
                user_remark_003: changeUerInfo.user_remark_003,
                user_remark_010: changeUerInfo.user_remark_010,
                user_remark_004: changeUerInfo.user_remark_004,
                user_remark_005: changeUerInfo.user_remark_005,
                user_remark_006: changeUerInfo.user_remark_006,
                user_remark_007: changeUerInfo.user_remark_007,
                user_remark_008: changeUerInfo.user_remark_008,
                user_remark_011: changeUerInfo.user_remark_011,
                user_email: changeUerInfo.user_email,
                upline_id_user: _this.$route.query.upline_id,
                isloading: false,
            };
            pageCommon
            .apiRequestCommon(accountApi, "changeUerInfo", requestData)
            .then(
                (res) => {
                    _this.isRequesting = false;
                    _this.$message.success("注册成功");
                    _this.handleToLogin();
                },
                (err) => {
                    _this.isRequesting = false;
                    if (err.sysUserLoginError) {
                    _this.$message.error("系统异常，请稍后刷新重试！");
                    } else {
                    _this.$message.error(err.data.msg);
                    }
                }
            );
        },
    },
};
</script>
<style scoped lang="less">
@import "../assets/css/common.less";
@import "../assets/css/loginreg.less";
.register {
    .main-inner {
        padding-top: 64px;
        padding-bottom: 64px;
        box-sizing: border-box;
            &.register-inner {
                width: 445px;
                height: 100%;
                overflow: hidden;
            .scrollbar {
                height: 100%;
                /deep/.el-scrollbar__wrap {
                    overflow-x: hidden;
                }
            }
            .register-body {
                width: 370px;
            }
            .logo-btn-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .logo {
                    width: 130px;
                    height: 50px;
                }
                .btn-tologin {
                    width: 82px;
                    height: 32px;
                    line-height: 32px;
                    font-size: 14px;
                }
            }
            .tab-item-main {
                .tab-item-people {
                    .icon-box {
                        background: url("../assets/icon_person_unselected.png") no-repeat
                        center center;
                        background-size: 20px 20px;
                    }
                }
                .tab-item-supplier {
                    .icon-box {
                        background: url("../assets/icon_supplier_unselected.png") no-repeat
                        center center;
                        background-size: 20px 20px;
                    }
                }
                &.active {
                    .tab-item-people {
                        .icon-box {
                            background: url("../assets/icon_person_selected.png") no-repeat
                                center center;
                            background-size: 20px 20px;
                        }
                    }
                    .tab-item-supplier {
                        .icon-box {
                            background: url("../assets/icon_supplier_selected.png") no-repeat
                                center center;
                            background-size: 20px 20px;
                        }
                    }
                }
            }
            .width100per {
                width: 100%;
            }
            .register-form,
            .people-form,
            .supplier-form {
                .form-item {
                    margin-top: 16px;
                    /deep/.el-form-item {
                        margin-bottom: 0px;
                        &.is-error {
                            margin-bottom: 32px;
                        }
                    }
                    &:first-child {
                        margin-top: 30px;
                    }
                    &:last-child {
                        /deep/.el-form-item {
                            margin-bottom: 0px;
                            &.is-error {
                                margin-bottom: 0;
                            }
                        }
                    }
                    &.auto-forget-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .btn-forget {
                            font-size: 14px;
                            font-family: "SourceHanSansCN";
                            color: rgb(102, 102, 102);
                            line-height: 14px;
                            cursor: pointer;
                        }
                    }
                    .phonecode,
                    .verifycode {
                        /deep/.el-input__inner {
                            padding-right: 113px;
                        }
                    }
                    .btn-phonecode {
                        position: absolute;
                        right: 5px;
                        top: 5px;
                        margin-left: 0;
                        margin-right: 0;
                    }
                    .img-code {
                        position: absolute;
                        right: 5px;
                        top: 5px;
                        margin-left: 0;
                        margin-right: 0;
                        cursor: pointer;
                    }
                }
                .btn-operate {
                    margin-top: 40px;
                }
            }
        }
    }
}
</style>
